<p>footer works!</p>
<footer class="page-footer">
    <div class="container">
      <div class="row">
        <div class="col l6 s12">
          <h5 class="white-text">Nossos contatos</h5>
          <p class="grey-text text-lighten-4">Fale conosco.</p>
        </div>
        <div class="col l4 offset-l2 s12">
          <h5 class="white-text">CONTATOS</h5>
          <ul>
            <li><a class="grey-text text-lighten-3" href="#!">Telefone:99999-9999</a></li>
            <li><a class="grey-text text-lighten-3" href="#!">Email: gmail.com</a></li>
            <li><a class="grey-text text-lighten-3" href="#!">Endereço: QKK 10 conjuto 10</a></li>
            <li><a class="grey-text text-lighten-3" href="#!">Brasília-DF</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container">
      © {{this.year}} Copyright 
     
      </div>
    </div>
  </footer>